import { render, staticRenderFns } from "./liveItemsComponent.vue?vue&type=template&id=2fa2184a&"
import script from "./liveItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./liveItemsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports